module.exports = __webpack_public_path__ + "img/user.578a4e0a.svg";